import Task from "@/services/client-tasks.js";
import Account from "@/services/account.js";
import axios from "axios";

const state = {
    selected: null,
    selectedDate: null,
    searchText: null,
    taskPermissions: null,
    loadingDetails: null,
    newTaskEnabled: false,
    abortController: null,
    badgeCount: 0
};

const getters = {
    selected: state => {
        return state.selected;
    },
    selectedDate: state => {
        return state.selectedDate;
    },
    searchText: state => {
        return state.searchText;
    },
    taskPermissions: state => {
        return state.taskPermissions;
    },
    loadingDetails: state => {
        return state.loadingDetails;
    },
    newTaskEnabled: state => {
        return state.newTaskEnabled;
    },
    badgeCount: state => {
        return state.badgeCount;
    }
};

const actions = {
    applyTaskDetails({ commit }, payload) {
        commit("setSelectedTask", payload?.record);
    },
    async getTaskDetails({ commit, state }, payload) {
        // set to false instead of null to allow frontend to load the skeleton instead of showing no task selected
        if (state.selected) {
            commit("setSelectedTask", false);
        }

        commit("setLoading", true);

        // Cancel the previous request if it exists
        if (state.abortController) {
            state.abortController.abort();
        }

        // Create a new AbortController for the current request
        state.abortController = new AbortController();

        //uses abortController to abort previous request and get latest one only.
        return Task.getTask(payload, state.abortController.signal)
            .then(async response => {
                //if 200
                commit("setSelectedTask", response.resource.data);
                commit("setPermissions", response.permissions);
            })
            .catch(error => error.data)
            .finally(() => commit("setLoading", false));
    },
    async checkTaskFeature({ commit }) {
        return Account.checkFeature("task")
            .then(response => {
                if (response.message.code == 200) {
                    commit(
                        "setNewTaskEnabled",
                        response.resource.is_enabled == 1
                    );
                }
            })
            .catch(error => error.data);
    }
};

const mutations = {
    setSelectedTask(state, selectedTask) {
        state.selected = selectedTask;
    },
    unSetSelectedTask(state) {
        state.selected = null;
        state.taskPermissions = null;
    },
    setDate(state, date) {
        state.selectedDate = date;
    },
    setSearch(state, search) {
        state.searchText = search;
    },
    setPermissions(state, permissions) {
        state.taskPermissions = permissions;
    },
    setLoading(state, loading) {
        state.loadingDetails = loading;
    },
    setNewTaskEnabled(state, newTaskEnabled) {
        state.newTaskEnabled = newTaskEnabled;
    },
    setBadgeCount(state, value) {
        state.badgeCount = value;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
